import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faDownLeftAndUpRightToCenter } from '@fortawesome/pro-light-svg-icons';

export type ProLightDownLeftAndUpRightToCenterProps = IconComponentProps;

export const ProLightDownLeftAndUpRightToCenter = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightDownLeftAndUpRightToCenterProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faDownLeftAndUpRightToCenter}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faDownLeftAndUpRightToCenter}
    />
  );
};

ProLightDownLeftAndUpRightToCenter.displayName = 'ProLightDownLeftAndUpRightToCenter';
